/**
 * The KaTeX release whose stylesheet the app and every exported HTML document
 * load. Kept equal to the installed `katex` package by `katexStylesheet.test.ts`,
 * which also pins `index.html` — static HTML that cannot import this constant.
 */
export const KATEX_VERSION = '0.19.0';

export const KATEX_STYLESHEET_URL = `https://cdn.jsdelivr.net/npm/katex@${KATEX_VERSION}/dist/katex.min.css`;
